import compile from './compile.directive';
import modalLink from './modallink.directive';
import courseLink from './courselink.directive';
import stopEvent from './stopevent.directive';
import { overlayButton } from './menu-button.directive';
import programCard from './programcard.directive.js';
import studySequence from './studysequence.directive.js';

const moduleName = 'usc.core.directives';

angular.module(moduleName, [])
    .directive('compile', ['$compile', compile])
    .directive('modalLink', ['contentService', '$uibModal', '$timeout', modalLink])
    .directive('courseLink', ['capsService', '$uibModal', '$timeout', '$filter', courseLink])
    .directive('stopEvent', stopEvent)
    .directive('overlayButton', ['$timeout', overlayButton])
    .directive('studySequence', ['capsService', '$compile', studySequence])
    .directive('programCard', [programCard]);

export default moduleName;